<template>
    <div class="sm:max-w-6xl mx-auto">
        <resource-index
            title="Участники курсов"
            endpoint="admin/customers/participants"
        >
            <template v-slot:table-header>
                <tr class="border-b">
                    <th class="text-left p-3 px-5" scope="col">Имя</th>
                    <th class="text-left p-3 px-5" scope="col">
                        Номер телефона
                    </th>
                    <th class="text-left p-3 px-5" scope="col">Email</th>
                    <th class="text-left p-3 px-5" scope="col">Курсы</th>
                    <th class="text-left p-3 px-5" scope="col"></th>
                </tr>
            </template>

            <template v-slot:table-filters="slotProps">
                <tr class="border-b bg-gray-100">
                    <th class="p-3 px-5" scope="col">
                        <text-field
                            :wrap="false"
                            v-model="slotProps.filters.name"
                        />
                    </th>

                    <th class="p-3 px-5" scope="col">
                        <text-field
                            :wrap="false"
                            v-model="slotProps.filters.phone"
                        />
                    </th>

                    <th class="p-3 px-5" scope="col">
                        <text-field
                            :wrap="false"
                            v-model="slotProps.filters.email"
                        />
                    </th>

                    <th class="p-3 px-5" scope="col">
                        <select-field
                            label="name"
                            valueName="id"
                            :wrap="false"
                            :options="selects.products"
                            v-model="slotProps.filters.product_id"
                        />
                    </th>

                    <th class="p-3 px-5" scope="col"></th>
                </tr>
            </template>

            <template v-slot:row="slotProps">
                <td class="p-3 px-5">{{ slotProps.entry.full_name }}</td>

                <td class="p-3 px-5">{{ slotProps.entry.phone }}</td>

                <td class="p-3 px-5">{{ slotProps.entry.email }}</td>

                <td class="p-3 px-5">
                    <div>
                        <span
                            :class="
                                order.paid_at
                                    ? 'bg-green-200 text-green-800'
                                    : 'bg-yellow-200 text-yellow-800'
                            "
                            class="inline-flex items-center px-2 py-1 rounded-lg text-xs font-bold"
                            v-for="order in slotProps.entry.orders"
                            :key="order.id"
                            >{{ order.product.name }}</span
                        >
                    </div>
                </td>

                <td class="p-3 px-5">
                    <router-link
                        :to="{
                            name: 'admin.customers.edit',
                            params: {
                                id: slotProps.entry.id,
                            },
                        }"
                        class="btn btn-info"
                        >Изменить</router-link
                    >
                </td>
            </template>
        </resource-index>
    </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex,
    },

    data() {
        return {
            selects: {},
        };
    },

    methods: {
        async fetchSelects() {
            await axios.get("/admin/products/courses").then((response) => {
                this.selects.products = response.data.data;
            });

            this.selects.ready = true;
        },
    },

    mounted() {
        this.fetchSelects();
    },
};
</script>